import { Component, EventEmitter, Input, OnInit } from '@angular/core';
import { PersonSearchService } from '../_services/person-search.service';
import { Subject, Subscription } from 'rxjs';
import { debounceTime } from 'rxjs/operators';
import { FormControl } from '@angular/forms';
import * as _ from 'underscore';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { SuggestedTitle } from '../openai/suggested-titles/suggested-titles.component';
import { ExtentedChip } from '../extended-chiplist/extended-chiplist.component';
import { RangeValues } from '../extended-slider/extended-slider.component';
import { GeneralConstants } from '../constants/GeneralConstants';
import { LocalStorageService } from '../_services/local-storage.service';
import { AggregationService } from '../_services/aggregation.service';
import PersonSearchResponse from '../common-interfaces-classes/PersonSearchResponse';
import { JdDataService } from '../jd-data.service';
import { ActivatedRoute } from '@angular/router';
import { ExtraInfo } from '../person-search-filter/ExtraInfo';

@Component({
  selector: 'app-similar-candidate-filter',
  templateUrl: './similar-candidate-filter.component.html',
  styleUrls: ['./similar-candidate-filter.component.scss']
})
export class SimilarCandidateFilterComponent implements OnInit {
  private typeAheadSubject = new Subject<{ event: Event, type: string }>();

  showJobtitleInput: boolean = false;
  showSkillInput: boolean = false;
  showLocationInput: boolean = false;
  showCompanyIndustryInput: boolean = false;
  showCompanyNameInput: boolean = false;
  showCompanySizeInput: boolean = false;
  showDegreeInput = false;
  showFieldOfStudyInput = false;
  showSchoolInput = false;

  showJobtitleInputLoader: boolean = false;
  showSkillInputLoader: boolean = false;
  showLocationInputLoader: boolean = false;
  showCompanyIndustryInputLoader: boolean = false;
  showCompanyNameInputLoader: boolean = false;
  showCompanySizeInputLoader: boolean = false;
  showDegreeInputLoader = false;
  showFieldOfStudyInputLoader = false;
  showSchoolInputLoader = false;

  showJobtitleMandatoryErrorMessage: boolean = false;
  showSkillMandatoryErrorMessage: boolean = false;
  showLocationMandatoryErrorMessage: boolean = false;
  showCompanyIndustryMandatoryErrorMessage: boolean = false;
  showCompanyNameMandatoryErrorMessage: boolean = false;
  showCompanySizeMandatoryErrorMessage: boolean = false;
  showDegreeMandatoryErrorMessage = false;
  showFieldOfStudyMandatoryErrorMessage = false;
  showSchoolMandatoryErrorMessage = false;
  

  maxJobtitleMandatoryFieldCount: number = 1;
  maxSkillMandatoryFieldCount: number = 5;
  maxLocationMandatoryFieldCount: number = 1;
  maxCompanyIndustryMandatoryFieldCount: number = 1;
  maxCompanyNameMandatoryFieldCount: number = 1;
  maxCompanySizeMandatoryFieldCount: number = 1;
  maxDegreeMandatoryFieldCount = 1;
  maxFieldOfStudyMandatoryFieldCount = 1;
  maxSchoolMandatoryFieldCount = 1;
  
  jobTitleMandatoryFieldCount: number = 0;
  skillMandatoryFieldCount: number = 0;
  locationMandatoryFieldCount: number = 0;
  companyIndustryMandatoryFieldCount: number = 0;
  companyNameMandatoryFieldCount: number = 0;
  companySizeMandatoryFieldCount: number = 0;
  degreeMandatoryFieldCount: number = 0;
  fieldOfStudyMandatoryFieldCount: number = 0;
  schoolMandatoryFieldCount: number = 0;


  jobTitleTypeAheads: any[] = [];
  skillTypeAheads: any[] = [];
  locationTypeAheads: any[] = [];
  companyIndustryTypeAheads: any[] = [];
  companyNameTypeAheads: any[] = [];
  companySizeTypeAheads: any[] = [];
  degreeTypeAheads: any[] = [];
  fieldOfStudyTypeAheads: any[] = [];
  schoolTypeAheads: any[] = [];

  jobTitleExtendedChipList: ExtentedChip[] = [];
  skillExtendedChipList: ExtentedChip[] = [];
  locationExtendedChipList: ExtentedChip[] = [];
  companyIndustryExtendedChipList: ExtentedChip[] = [];
  companyNameExtendedChipList: ExtentedChip[] = [];
  companySizeExtendedChipList: ExtentedChip[] = [];
  degreeExtendedChipList: ExtentedChip[] = [];
  fieldOfStudyExtendedChipList: ExtentedChip[] = [];
  schoolExtendedChipList: ExtentedChip[] = [];

  // Keeping track of all subscriptions to unsubscribe later
  subscriptions: Subscription[] = [];
  similarObject: any;

  isOpenAITitleLoading: boolean = true;
  showOpenAITitleSuggestions: number;

  isOpenAISkillsLoading: boolean = false;
  showOpenAISkillsSuggestions: number;

  jobTitleInput: FormControl = new FormControl(null);
  skillInput: FormControl = new FormControl(null);
  locationInput: FormControl = new FormControl(null);
  companyIndustryInput: FormControl = new FormControl(null);
  companyNameInput: FormControl = new FormControl(null);
  companySizeInput: any = [];
  degreeInput: FormControl = new FormControl(null);
  fieldOfStudyInput: FormControl = new FormControl(null);
  schoolInput: FormControl = new FormControl(null);

  companySizeOption: any = ["1-10", "11-50", "51-200", "201-500", "501-1000", "1001-5000", "5001-10000", "10001+"];

  updatedAiTitleChips: EventEmitter<SuggestedTitle[]> = new EventEmitter<SuggestedTitle[]>();

  updatedAiSkillChips: EventEmitter<SuggestedTitle[]> = new EventEmitter<SuggestedTitle[]>();

  selectedTitles: SuggestedTitle[] = [];

  selectedSkills: SuggestedTitle[] = [];

  rangeSliderLowValue: number = 0;
  rangeSliderHighValue: number = 10;

  rangeSliderMinValue: number = 0;
  rangeSliderMaxValue: number = 30;
  appendMax: string = "+";

  isCalledFromJD: boolean;
  recCandCount: number = null; 
  recCandLoader = true;
  
  get openAIJobTitles(): string {
    return this.jobTitleExtendedChipList.filter(jt => !jt.isSuggested).map(jobTitle => `"${jobTitle.name}"`).join(' OR ') || '';
  }

  get openAISkills(): string {
    return this.skillExtendedChipList.filter(s => !s.isSuggested).map(skill => `"${skill.name}"`).join(' OR ') || '';
  }

  get openAIExcludeJobTitles(): string[] {
    return this.jobTitleExtendedChipList.filter(jt => !jt.isSuggested).map(jobTitle => jobTitle.name);
  }

  get openAIExcludeSkills(): string[] {
    return this.skillExtendedChipList.filter(s => !s.isSuggested).map(skill => skill.name);
  }

  showregion;
  showLocationError = false;
  showJobTitleError = false;

  @Input() type: "open" | "edit";

  constructor(private personSearchService: PersonSearchService, private activeModal: NgbActiveModal,
    private localStorageService: LocalStorageService, private aggService: AggregationService,
    private jdDataService: JdDataService, private activatedRoute: ActivatedRoute) { }

  ngOnInit() {
    this.similarObject = this.personSearchService.getsimilarcandidatesdata();
    this.isCalledFromJD = this.similarObject?.calledfrom === GeneralConstants.REDIRECT_SOURCES.JOB_DESCRIPTION;
    this.populateChipList();

    const typeaheadSub = this.typeAheadSubject.pipe(debounceTime(500)).subscribe(({ event, type }) => {
      this.typeAheadSearch(event, type);
    });
    this.subscriptions.push(typeaheadSub);

    this.setSimDataAndFetchRecCount();

    const recCandidateSub = this.aggService.recCandidateDataEvent.subscribe(
      res => this.setRecommendedCount(res),
      err => this.recCandLoader = false
    );
    this.subscriptions.push(recCandidateSub);
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach(sub => sub.unsubscribe());
  }

  private setRecommendedCount(response: PersonSearchResponse) {
    this.recCandCount = response?.totalresultscount;
    this.recCandLoader = false;
  }

  /**
   * Show and hide inputs
   * @param type 
   */
  toggleInputDisplay(type: string) {
    this.removeErrorMessages();
    switch(type) {
      case 'jobTitle': this.showJobtitleInput = !this.showJobtitleInput; this.jobTitleTypeAheads = []; break;
      case 'skill': this.showSkillInput = !this.showSkillInput; this.skillTypeAheads = []; break;
      case 'location': this.showLocationInput = !this.showLocationInput; this.locationTypeAheads = []; break;
      case 'companyIndustry': this.showCompanyIndustryInput = !this.showCompanyIndustryInput; this.companyIndustryTypeAheads = []; break;
      case 'companyName': this.showCompanyNameInput = !this.showCompanyNameInput; this.companyNameTypeAheads = []; break;
      case 'companySize': this.showCompanySizeInput = !this.showCompanySizeInput; this.companySizeTypeAheads = []; break;
      case 'degree': this.showDegreeInput = !this.showDegreeInput; this.degreeTypeAheads = []; break;
      case 'fieldOfStudy': this.showFieldOfStudyInput = !this.showFieldOfStudyInput; this.fieldOfStudyTypeAheads = []; break;
      case 'school': this.showSchoolInput = !this.showSchoolInput; this.schoolTypeAheads = []; break;
    }
  }

  // Call this function whenever the user types something
  onTypeAheadSearch(event: Event, type: string) {
    // Emit the event and type as an object through the typeAheadSubject to apply debounce
    this.typeAheadSubject.next({ event, type });
  }

  typeAheadSearch(event, type: string) {
    const searchValue = (event.target as HTMLInputElement).value.trim();
    if (searchValue.length < 3) return;

    const requestObject = {};

    switch (type) {
      case 'jobTitle': {
        requestObject['typeahead'] = 'typeahead_jobtitle';
        requestObject['input'] = searchValue;
        this.showJobtitleInputLoader = true;
        this.personSearchService.getPersonSearchListing(searchValue, 'jobtitle').subscribe((response: any) => {
          if (response.status == 'success' && response.data) {
            this.jobTitleTypeAheads = response.data;
            this.showJobtitleInputLoader = false;
          }
        });
        break;
      }
      case 'skill': {
        requestObject['typeahead'] = 'typeahead_skills';
        requestObject['input'] = searchValue;
        this.showSkillInputLoader = true;
        this.personSearchService.getPersonSearchListing(searchValue, 'skill').subscribe((response: any) => {
          if (response.status == 'success' && response.data) {
            this.skillTypeAheads = response.data;
            this.showSkillInputLoader = false;
          }
        });
        break;
      }
      case 'location': {
        requestObject['typeahead'] = 'typeahead_location';
        requestObject['input'] = searchValue;
        this.showLocationInputLoader = true;
        this.personSearchService.getPersonSearchListing(searchValue, 'location', this.showregion).subscribe((response: any) => {
          if (response.status == 'success' && response.data) {
            this.locationTypeAheads = response.data;
            this.showLocationInputLoader = false;
          }
        });
        break;
      }
      case 'companyIndustry': {
        requestObject['typeahead'] = 'typeahead_industry';
        requestObject['input'] = searchValue;
        this.showCompanyIndustryInputLoader = true;
        this.personSearchService.getPersonSearchListing(searchValue, 'industry').subscribe((response: any) => {
          if (response.status == 'success' && response.data) {
            this.companyIndustryTypeAheads = response.data;
            this.showCompanyIndustryInputLoader = false;
          }
        });
        break;
      }
      case 'companyName': {
        requestObject['typeahead'] = 'typeahead_company';
        requestObject['input'] = searchValue;
        this.showCompanyNameInputLoader = true;
        this.personSearchService.getPersonSearchListing(searchValue, 'company').subscribe((response: any) => {
          if (response.status == 'success' && response.data) {
            const companyList = response.data;
            this.personSearchService.getCompanyLogo({ companynames: companyList.map(c => c.value)}).subscribe((response: any) => {
              this.companyNameTypeAheads = response.message;
            });
            this.showCompanyNameInputLoader = false
          }
        });
        break;
      }
      case 'degree': {
        requestObject['typeahead'] = 'typeahead_education';
        requestObject['input'] = searchValue;
        this.showDegreeInputLoader = true;
        this.personSearchService.getPersonSearchListing(searchValue, 'education').subscribe((response: any) => {
          if (response.status == 'success' && response.data) {
            this.degreeTypeAheads = response.data;
            this.showDegreeInputLoader = false;
          }
        });
        break;
      }
      case 'fieldOfStudy': {
        requestObject['typeahead'] = 'typeahead_fieldofstudy';
        requestObject['input'] = searchValue;
        this.showFieldOfStudyInputLoader = true;
        this.personSearchService.getPersonSearchListing(searchValue, 'fieldofstudy').subscribe((response: any) => {
          if (response.status == 'success' && response.data) {
            this.fieldOfStudyTypeAheads = response.data;
            this.showFieldOfStudyInputLoader = false;
          }
        });
        break;
      }
      case 'school': {
        requestObject['typeahead'] = 'typeahead_school';
        requestObject['input'] = searchValue;
        this.showSchoolInputLoader = true;
        this.personSearchService.getPersonSearchListing(searchValue, 'school').subscribe((response: any) => {
          if (response.status == 'success' && response.data) {
            this.schoolTypeAheads = response.data;
            this.showSchoolInputLoader = false;
          }
        });
        break;
      }
    }
  }

  populateChipList() {
    const similarObjectData = this.similarObject.data;

    similarObjectData.jobtitle && similarObjectData.jobtitle.forEach(j => {
      j.isMandatory && this.jobTitleMandatoryFieldCount++;
      this.jobTitleExtendedChipList.push({ name: j.key.replace(/\.searchastext/g, ''), value: j.key, starred: j.isMandatory, type: 'Job Title', canStar: true, isSuggested: j.isSuggested, key: j.suggestedKey });
    });

    similarObjectData.skills && similarObjectData.skills.forEach(s => {
      s.isMandatory && this.skillMandatoryFieldCount++;
      this.skillExtendedChipList.push({ name: s.key.replace(/\.searchastext/g, ''), value: s.key, starred: s.isMandatory, type: 'Skill', canStar: true, isSuggested: s.isSuggested, key: s.suggestedKey });
    } );

    similarObjectData.currentlocation && similarObjectData.currentlocation.forEach(l => {
      l.isMandatory && this.locationMandatoryFieldCount++;
      this.locationExtendedChipList.push({ name: l.key.replace(/\.searchastext/g, ''), value: l.key, starred: l.isMandatory, type: 'Location', canStar: true, isSuggested: l.isSuggested, key: l.suggestedKey });
    });

    similarObjectData.jobindustryname && similarObjectData.jobindustryname.forEach(ci => {
      ci.isMandatory && this.companyIndustryMandatoryFieldCount++;
      this.companyIndustryExtendedChipList.push({ name: ci.key.replace(/\.searchastext/g, ''), value: ci.key, starred: ci.isMandatory, type: 'Company Industry', canStar: true, isSuggested: ci.isSuggested, key: ci.suggestedKey });
    });

    similarObjectData.jobcompanyname && similarObjectData.jobcompanyname.forEach(cn => {
      cn.isMandatory && this.companyNameMandatoryFieldCount++;
      this.companyNameExtendedChipList.push({ name: cn.key.replace(/\.searchastext/g, ''), value: cn.key, starred: cn.isMandatory, type: 'Company Name', canStar: true, isSuggested: cn.isSuggested, key: cn.suggestedKey });
      this.companyNameExtendedChipList?.length && this.getCompanyLogoForCompanyChips( _.pluck(this.companyNameExtendedChipList, 'value'));
    });

    similarObjectData.companysize && similarObjectData.companysize.forEach(cs => {
      cs.isMandatory && this.companySizeMandatoryFieldCount++;
      this.companySizeExtendedChipList.push({ name: cs.key.replace(/\.searchastext/g, ''), value: cs.key, starred: cs.isMandatory, type: 'Company Size', canStar: true, isSuggested: cs.isSuggested, key: cs.suggestedKey });
    });

    this.isCalledFromJD && similarObjectData?.degrees && similarObjectData.degrees.forEach(el => {
      el.isMandatory && this.degreeMandatoryFieldCount++;
      this.degreeExtendedChipList.push({ name: el.key.replace(/\.searchastext/g, ''), value: el.key, starred: el.isMandatory, type: 'Degree', canStar: true, isSuggested: el.isSuggested, key: el.suggestedKey });
    })
    // this.degreeExtendedChipList = similarObjectData.degrees.map(cs => ({ name: cs.key.replace(/\.searchastext/g, ''), value: cs.key, starred: cs.isMandatory, type: 'Degree', canStar: true, isSuggested: cs.isSuggested, key: cs.suggestedKey }));
    this.isCalledFromJD && similarObjectData?.fieldOfStudy && similarObjectData.fieldOfStudy.forEach(el => {
      el.isMandatory && this.fieldOfStudyMandatoryFieldCount++;
      this.fieldOfStudyExtendedChipList.push({ name: el.key.replace(/\.searchastext/g, ''), value: el.key, starred: el.isMandatory, type: 'Field of study', canStar: true, isSuggested: el.isSuggested, key: el.suggestedKey });
    })
    // this.fieldOfStudyExtendedChipList = similarObjectData.fieldOfStudy.map(cs => ({ name: cs.key.replace(/\.searchastext/g, ''), value: cs.key, starred: cs.isMandatory, type: 'Field of study', canStar: true, isSuggested: cs.isSuggested, key: cs.suggestedKey }));
    this.isCalledFromJD && similarObjectData?.schools && similarObjectData.schools.forEach(el => {
      el.isMandatory && this.schoolMandatoryFieldCount++;
      this.schoolExtendedChipList.push({ name: el.key.replace(/\.searchastext/g, ''), value: el.key, starred: el.isMandatory, type: 'School', canStar: true, isSuggested: el.isSuggested, key: el.suggestedKey });
    });
    // this.schoolExtendedChipList = similarObjectData.schools.map(cs => ({ name: cs.key.replace(/\.searchastext/g, ''), value: cs.key, starred: cs.isMandatory, type: 'School', canStar: true, isSuggested: cs.isSuggested, key: cs.suggestedKey }));
    this.companySizeInput = similarObjectData.companysize ? similarObjectData.companysize.map(cs => cs.key) : [];

    const updateTitleSuggestions = this.jobTitleExtendedChipList.filter(jt => jt.isSuggested).map<SuggestedTitle>(js => ({ name: js.name, selected: true, type: 'title', key: js.key }));
    const updateSkillSuggestions = this.skillExtendedChipList.filter(jt => jt.isSuggested).map<SuggestedTitle>(js => ({ name: js.name, selected: true, type: 'skill', key: js.key }));
   
    const fromYrsOfExperience = similarObjectData.fromYrsOfExperience;
    const toYrsOfExperinece = similarObjectData.toYrsOfExperinece;

    this.rangeSliderLowValue = fromYrsOfExperience >= 30 ? 30 : fromYrsOfExperience;
    this.rangeSliderHighValue = toYrsOfExperinece >= 30 ? 30 : toYrsOfExperinece;

    this.selectedTitles = updateTitleSuggestions;
    this.selectedSkills = updateSkillSuggestions;

    this.updatedAiTitleChips.emit(updateTitleSuggestions);
    this.updatedAiSkillChips.emit(updateSkillSuggestions);

    if (similarObjectData.locationcontinent) {
      this.showregion = similarObjectData.locationcontinent?.toLowerCase();
      // this.localStorageService.setItem('region', this.showregion);
    } else if(this.isCalledFromJD) {
      this.showregion = this.localStorageService.getItem('region');
    }
  }

  openaiTitleLoading({ state, count }) {
    this.isOpenAITitleLoading = state;
    this.showOpenAITitleSuggestions = count;
  }

  setTitleSuggestions(suggestions: SuggestedTitle[]) {
    this.removeErrorMessages();
    // generate key for each suggestion
    const suggestionsWithKey = suggestions.map(suggestion => {
      return {
        name: suggestion.name,
        value: `${suggestion.name}.searchastext`,
        isMandatory: false,
        canStar: true,
        type: 'Job Title',
        isSuggested: true,
        key: suggestion.key
      };
    });
    const existingSuggestions = this.jobTitleExtendedChipList.filter(suggestion => suggestion.isSuggested);
    const newSuggestions = suggestionsWithKey.filter(suggestion => !existingSuggestions.find(existingSuggestion => existingSuggestion.name === suggestion.name));
    let removedSuggestions = [];
    if(newSuggestions.length) {
      this.jobTitleExtendedChipList = this.jobTitleExtendedChipList.concat(newSuggestions);
    } else {
      removedSuggestions = existingSuggestions.filter(suggestion => !suggestionsWithKey.find(s => s.name === suggestion.name));
      removedSuggestions.length && (this.jobTitleExtendedChipList = this.jobTitleExtendedChipList.filter(chiplist => chiplist.name != removedSuggestions[0].name));
    }
    this.showJobTitleError = this.jobTitleExtendedChipList.length === 0;
    this.setSimDataAndFetchRecCount();
  }

  openaiSkillsLoading({ state, count }) {
    this.isOpenAISkillsLoading = state;
    this.showOpenAISkillsSuggestions = count;
  }

  setSkillsSuggestions(suggestions: SuggestedTitle[]) {
    this.removeErrorMessages();
    const suggestionsWithKey = suggestions.map(suggestion => {
      return {
        name: suggestion.name,
        value: `${suggestion.name}.searchastext`,
        isMandatory: false,
        canStar: true,
        type: 'Skill',
        isSuggested: true,
        key: suggestion.key
      };
    });
    const existingSuggestions = this.skillExtendedChipList.filter(suggestion => suggestion.isSuggested);
    const newSuggestions = suggestionsWithKey.filter(suggestion => !existingSuggestions.find(existingSuggestion => existingSuggestion.name === suggestion.name));
    let removedSuggestions = [];
    if(newSuggestions.length) {
      this.skillExtendedChipList = this.skillExtendedChipList.concat(newSuggestions);
    } else {
      removedSuggestions = existingSuggestions.filter(suggestion => !suggestionsWithKey.find(s => s.name === suggestion.name));
      removedSuggestions.length && (this.skillExtendedChipList = this.skillExtendedChipList.filter(chiplist => chiplist.name != removedSuggestions[0].name));
    }
    this.setSimDataAndFetchRecCount();
  }

  setUpdatedChips(event: any, type: string) {
    this.removeErrorMessages();
    switch(type) {
      case 'jobTitle': {
        let removedSuggestions = [];
        this.jobTitleExtendedChipList = event.filter(e => {
          const action = e.action;
          action && delete e.action;

          if (action === 'removed') {
            e.starred && this.jobTitleMandatoryFieldCount--;
            e.isSuggested && removedSuggestions.push({ name: e.name, selected: false, type: 'title', key: e.key });
            return false;
          }

          if(action == 'starred') {
            this.jobTitleMandatoryFieldCount++;
            if(this.jobTitleMandatoryFieldCount > this.maxJobtitleMandatoryFieldCount) {
              e.starred = false;
              this.jobTitleMandatoryFieldCount--;
              this.showJobtitleMandatoryErrorMessage = true;
            }
          }

          if(action == 'unstarred') {
            this.jobTitleMandatoryFieldCount--;
          }

          return true;
        });
        this.updatedAiTitleChips.emit(removedSuggestions);
        break;
      }
      case 'skill': {
        let removedSuggestions = [];
        this.skillExtendedChipList = event.filter(e => {
          const action = e.action;
          action && delete e.action;

          if (action === 'removed') {
            e.starred && this.skillMandatoryFieldCount--;
            e.isSuggested && removedSuggestions.push({ name: e.name, selected: false, type: 'skill', key: e.key });
            return false;
          }

          if(action == 'starred') {
            this.skillMandatoryFieldCount++;
            if(this.skillMandatoryFieldCount > this.maxSkillMandatoryFieldCount) {
              e.starred = false;
              this.skillMandatoryFieldCount--;
              this.showSkillMandatoryErrorMessage = true;
            }
          }

          if(action == 'unstarred') {
            this.skillMandatoryFieldCount--;
          }

          return true;
        });
        this.updatedAiSkillChips.emit(removedSuggestions);
        break;
      }
      case 'location': {
        this.locationExtendedChipList = event.filter(e => {
          const action = e.action;
          action && delete e.action;

          if(action == 'removed') {
            e.starred && this.locationMandatoryFieldCount--;
            return false;
          }

          if(action == 'starred') {
            this.locationMandatoryFieldCount++;
            if(this.locationMandatoryFieldCount > this.maxLocationMandatoryFieldCount) {
              e.starred = false;
              this.locationMandatoryFieldCount--;
              this.showLocationMandatoryErrorMessage = true;
            }
          }

          if(action == 'unstarred') {
            this.locationMandatoryFieldCount--;
          }

          return true;
        }); 
        break;
      }
      case 'companyIndustry': {
        this.companyIndustryExtendedChipList = event.filter(e => {
          const action = e.action;
          action && delete e.action;

          if(action == 'removed') {
            e.starred && this.companyIndustryMandatoryFieldCount--;
            return false;
          }

          if(action == 'starred') {
            this.companyIndustryMandatoryFieldCount++;
            if(this.companyIndustryMandatoryFieldCount > this.maxCompanyIndustryMandatoryFieldCount) {
              e.starred = false;
              this.companyIndustryMandatoryFieldCount--;
              this.showCompanyIndustryMandatoryErrorMessage = true;
            }
          }

          if(action == 'unstarred') {
            this.companyIndustryMandatoryFieldCount--;
          }

          return true;
        }); 
        break;
      }
      case 'companyName': { 
        this.companyNameExtendedChipList = event.filter(e => {
          const action = e.action;
          action && delete e.action;

          if(action == 'removed') {
            e.starred && this.companyNameMandatoryFieldCount--;
            return false;
          }

          if(action == 'starred') {
            this.companyNameMandatoryFieldCount++;
            if(this.companyNameMandatoryFieldCount > this.maxCompanyNameMandatoryFieldCount) {
              e.starred = false;
              this.companyNameMandatoryFieldCount--;
              this.showCompanyNameMandatoryErrorMessage = true;
            }
          }

          if(action == 'unstarred') {
            this.companyNameMandatoryFieldCount--;
          }

          return true;
        }); 
        break;
      }
      case 'companySize': {
        this.companySizeExtendedChipList = event.filter(e => {
          const action = e.action;
          action && delete e.action;
          if(action == 'removed') {
            e.starred && this.companySizeMandatoryFieldCount--;
            return false;
          }

          if(action == 'starred') {
            this.companySizeMandatoryFieldCount++;
            if(this.companySizeMandatoryFieldCount > this.maxCompanySizeMandatoryFieldCount) {
              e.starred = false;
              this.companySizeMandatoryFieldCount--;
              this.showCompanySizeMandatoryErrorMessage = true;
            }
          }

          if(action == 'unstarred') {
            this.companySizeMandatoryFieldCount--;
          }

          return true;

        }); 
        this.companySizeInput = this.companySizeExtendedChipList.map(e => e.name); 
        break;
      }
      case 'degree': { 
        this.degreeExtendedChipList = event.filter(e => {
          const action = e.action;
          action && delete e.action;

          if(action == 'removed') {
            e.starred && this.degreeMandatoryFieldCount--;
            return false;
          }

          if(action == 'starred') {
            this.degreeMandatoryFieldCount++;
            if(this.degreeMandatoryFieldCount > this.maxDegreeMandatoryFieldCount) {
              e.starred = false;
              this.degreeMandatoryFieldCount--;
              this.showDegreeMandatoryErrorMessage = true;
            }
          }

          if(action == 'unstarred') {
            this.degreeMandatoryFieldCount--;
          }
          return true;
        }); 
        break;
      }
      // case 'degree': this.degreeExtendedChipList = event.filter(e => e.action != 'removed'); break;
      case 'fieldOfStudy': { 
        this.fieldOfStudyExtendedChipList = event.filter(e => {
          const action = e.action;
          action && delete e.action;

          if(action == 'removed') {
            e.starred && this.fieldOfStudyMandatoryFieldCount--;
            return false;
          }

          if(action == 'starred') {
            this.fieldOfStudyMandatoryFieldCount++;
            if(this.fieldOfStudyMandatoryFieldCount > this.maxFieldOfStudyMandatoryFieldCount) {
              e.starred = false;
              this.fieldOfStudyMandatoryFieldCount--;
              this.showFieldOfStudyMandatoryErrorMessage = true;
            }
          }

          if(action == 'unstarred') {
            this.fieldOfStudyMandatoryFieldCount--;
          }
          return true;
        }); 
        break;
      }
      // case 'fieldOfStudy': this.fieldOfStudyExtendedChipList = event.filter(e => e.action != 'removed'); break;
      case 'school': { 
        this.schoolExtendedChipList = event.filter(e => {
          const action = e.action;
          action && delete e.action;

          if(action == 'removed') {
            e.starred && this.schoolMandatoryFieldCount--;
            return false;
          }

          if(action == 'starred') {
            this.schoolMandatoryFieldCount++;
            if(this.schoolMandatoryFieldCount > this.maxSchoolMandatoryFieldCount) {
              e.starred = false;
              this.schoolMandatoryFieldCount--;
              this.showSchoolMandatoryErrorMessage = true;
            }
          }

          if(action == 'unstarred') {
            this.schoolMandatoryFieldCount--;
          }
          return true;
        }); 
        break;
      }
      // case 'school': this.schoolExtendedChipList = event.filter(e => e.action != 'removed'); break;
    }
    this.setSimDataAndFetchRecCount();
  }

  addToSelectedList(item, type: string, from: any = null) {
    this.removeErrorMessages();
    const inputValue = from == 'enter' ? item.target.value : from == 'submit' ? item : item.option.value.key;
    if(!inputValue) return;
    switch (type) {
      case 'jobTitle': {
        const isInputValuePresent = this.jobTitleExtendedChipList.findIndex(jt => jt.name.toLowerCase() == inputValue.toLowerCase());
        (isInputValuePresent == -1) && this.jobTitleExtendedChipList.push({ name: inputValue, value: from == 'enter' ? inputValue+".searchastext" : from == 'submit' ? inputValue+".searchastext" : inputValue, isSuggested: false, canStar: true, type: 'Job Title' });
        this.jobTitleInput.reset();
        this.showJobtitleInput = false;
        this.showJobTitleError = false;
        break;
      }
       case 'skill': {
        const isInputValuePresent = this.skillExtendedChipList.findIndex(s => s.name.toLowerCase() == inputValue.toLowerCase());
        (isInputValuePresent == -1) && this.skillExtendedChipList.push({ name: inputValue, value: from == 'enter' ? inputValue+".searchastext" : from == 'submit' ? inputValue+".searchastext" : inputValue, isSuggested: false, canStar: true, type: 'Skill' });
        this.skillInput.reset();
        this.showSkillInput = false;
        break;
      }
      case 'location': {
        if (from === 'enter')
          break;

        const isInputValuePresent = this.locationExtendedChipList.findIndex(s => s.name.toLowerCase() == inputValue.toLowerCase());
        (isInputValuePresent == -1) && this.locationExtendedChipList.push({ name: inputValue, value: from == 'enter' ? inputValue+".searchastext" : from == 'submit' ? inputValue+".searchastext" : inputValue, isSuggested: false, type: 'Location', canStar: true });
        this.locationInput.reset();
        this.showLocationInput = false;
        this.showLocationError = false;
        break;
      }
      case 'companyIndustry': {
        const isInputValuePresent = this.companyIndustryExtendedChipList.findIndex(s => s.name.toLowerCase() == inputValue.toLowerCase());
        (isInputValuePresent == -1) && this.companyIndustryExtendedChipList.push({ name: inputValue, value: from == 'enter' ? inputValue+".searchastext" : from == 'submit' ? inputValue+".searchastext" : inputValue, isSuggested: false, canStar: true, type: 'Company Industry' });
        this.companyIndustryInput.reset();
        this.showCompanyIndustryInput = false;
        break;
      }
      case 'companyName': {
        const isInputValuePresent = this.companyNameExtendedChipList.findIndex(s => s.name.toLowerCase() == inputValue.toLowerCase());
        (isInputValuePresent == -1) && this.companyNameExtendedChipList.push({ name: inputValue, value: from == 'enter' ? inputValue+".searchastext" : from == 'submit' ? inputValue+".searchastext" : inputValue, isSuggested: false, canStar: true, type: 'Company Name' });
        this.companyNameInput.reset();
        this.showCompanyNameInput = false;
        this.getCompanyLogoForCompanyChips( _.pluck(this.companyNameExtendedChipList, 'value'));
        break;
      }
      case 'companySize': {
        const updatedValue = item.itemValue;
        if(this.companySizeExtendedChipList.length > item.value.length) {
          // item is removed
          this.companySizeExtendedChipList = this.companySizeExtendedChipList.filter(ci => {
            if(ci.name == updatedValue) {
              ci.starred && this.companySizeMandatoryFieldCount--;
              return false;
            }
            return true;
          });
        } else {
          // item is added
          this.companySizeExtendedChipList.push({ name: updatedValue, canStar: true, starred: false, value: updatedValue, type: 'Company Size' });
        }
        this.companySizeInput = item.value;
        this.showCompanySizeInput = false;
        break;
      }
      case 'degree': {
        const isInputValuePresent = this.degreeExtendedChipList.findIndex(s => s.name.toLowerCase() == inputValue.toLowerCase());
        (isInputValuePresent == -1) && this.degreeExtendedChipList.push({ name: inputValue, value: from == 'enter' ? inputValue+".searchastext" : from == 'submit' ? inputValue+".searchastext" : inputValue, isSuggested: false, canStar: true, type: 'Degree' });
        this.degreeInput.reset();
        this.showDegreeInput = false;
        break;
      }
      case 'fieldOfStudy': {
        const isInputValuePresent = this.fieldOfStudyExtendedChipList.findIndex(s => s.name.toLowerCase() == inputValue.toLowerCase());
        (isInputValuePresent == -1) && this.fieldOfStudyExtendedChipList.push({ name: inputValue, value: from == 'enter' ? inputValue+".searchastext" : from == 'submit' ? inputValue+".searchastext" : inputValue, isSuggested: false, canStar: true, type: 'Field of study' });
        this.fieldOfStudyInput.reset();
        this.showFieldOfStudyInput = false;
        break;
      }
      case 'school': {
        const isInputValuePresent = this.schoolExtendedChipList.findIndex(s => s.name.toLowerCase() == inputValue.toLowerCase());
        (isInputValuePresent == -1) && this.schoolExtendedChipList.push({ name: inputValue, value: from == 'enter' ? inputValue+".searchastext" : from == 'submit' ? inputValue+".searchastext" : inputValue, isSuggested: false, canStar: true, type: 'School' });
        this.schoolInput.reset();
        this.showSchoolInput = false;
        break;
      }
    }
    this.setSimDataAndFetchRecCount();
  }

  getCompanyLogoForCompanyChips(companyList: Array<string>) { 
    if(!companyList || !companyList.length) return;
    const updatedCompanyList = companyList.map(companyName => {
      const name = companyName.split(".searchastext");
      return (name[0]).toLowerCase();
    }).filter(Boolean);

    this.personSearchService.getCompanyLogo({ companynames: updatedCompanyList }).subscribe((res: any) => {
      this.companyNameExtendedChipList?.length && this.companyNameExtendedChipList.map(company => {
        if (res && res.message?.length) {
          res.message.map(logosData => {
            if (((logosData.key).toLowerCase() === (company.value).toLowerCase()) || ((logosData.key).toLowerCase() === (company.name).toLowerCase()) ) {
              company['companylogo'] = logosData?.companylogo;
            }
          })
        }
      })
    })
  }

  redirectToListing(action?: string) {
    if(action == 'close') this.activeModal.close({ action: 'close'});
    
    if (!this.validStateForRedirection) {
      this.showLocationError = this.locationExtendedChipList.length === 0;
      this.showJobTitleError = this.jobTitleExtendedChipList.length === 0;
      return;
    }

    this.similarObject.data = this.updatedSimilarObjectData;
    if(this.isCalledFromJD) {
      this.localStorageService.setItem('similar-region', this.showregion);
      this.localStorageService.setItem('region', this.showregion);
    } 
    // this.similarObject.data.toYrsOfExperinece = this.rangeSliderHighValue;
    // this.similarObject.data.fromYrsOfExperience = this.rangeSliderLowValue;
    this.activeModal.close({...this.similarObject, action: 'submit'});
  }

  private get validStateForRedirection() {
    if (this.isCalledFromJD) {
      return this.locationExtendedChipList.length > 0 && 
        this.jobTitleExtendedChipList.length > 0;
    }
    return true;
  }

  private get updatedSimilarObjectData() {
    const scObject = Object.assign({}, this.similarObject.data);
    scObject.jobtitle = this.jobTitleExtendedChipList.map(jt => ({ key: jt.value ? jt.value : jt.name, isMandatory: jt.starred, isSuggested: jt.isSuggested, suggestedKey: jt.key }));
    scObject.skills = this.skillExtendedChipList.map(skill => ({ key: skill.value ? skill.value : skill.name, isMandatory: skill.starred, isSuggested: skill.isSuggested, suggestedKey: skill.key }));
    scObject.currentlocation = this.locationExtendedChipList.map(location => ({ key: location.value ? location.value : location.name, isMandatory: location.starred, isSuggested: location.isSuggested, suggestedKey: location.key }));
    scObject.jobindustryname = this.companyIndustryExtendedChipList.map(ci => ({ key: ci.value ? ci.value : ci.name, isMandatory: ci.starred, isSuggested: ci.isSuggested, suggestedKey: ci.key }));
    scObject.jobcompanyname = this.companyNameExtendedChipList.map(cn => ({ key: cn.value ? cn.value : cn.name, isMandatory: cn.starred, isSuggested: cn.isSuggested, suggestedKey: cn.key }));
    scObject.companysize = this.companySizeExtendedChipList.map(cs => ({ key: cs.value ? cs.value : cs.name, isMandatory: cs.starred, isSuggested: cs.isSuggested, suggestedKey: cs.key }));
    scObject.degrees = this.degreeExtendedChipList.map(cs => ({ key: cs.value ? cs.value : cs.name, isMandatory: cs.starred, isSuggested: cs.isSuggested, suggestedKey: cs.key }));
    scObject.fieldOfStudy = this.fieldOfStudyExtendedChipList.map(cs => ({ key: cs.value ? cs.value : cs.name, isMandatory: cs.starred, isSuggested: cs.isSuggested, suggestedKey: cs.key }));
    scObject.schools = this.schoolExtendedChipList.map(cs => ({ key: cs.value ? cs.value : cs.name, isMandatory: cs.starred, isSuggested: cs.isSuggested, suggestedKey: cs.key }));
    scObject.locationcontinent = this.showregion;
    return scObject;
  }

  private setSimDataAndFetchRecCount() {
    this.recCandLoader = true;
    this.getPersonSearchRecommendedCandidates();
  }

  private getPersonSearchRecommendedCandidates() {
    const request = this.aggService.getRequestWithFilters(this.extraInfoWithData);
    delete request.aggregatetype;
    this.personSearchService.getPersonSearchRecommendCandidates(request).subscribe(response => {
      const psResp = new PersonSearchResponse();
      if (response.status == 'success' && response?.data?.totalresultscount) {
        psResp.totalresultscount = response?.data?.totalresultscount;
      } else {
        psResp.totalresultscount = null;
      }
      this.setRecommendedCount(psResp);
    });
  }

  private get extraInfoWithData() {
    const extraInfo = new ExtraInfo();
    extraInfo.calledFrom = GeneralConstants.COMPONENT_NAME.SC_MODAL;
    extraInfo.redirectData = this.updatedSimilarObjectData;
    extraInfo.redirectData.continentstobeincluded = this.showregion;
    extraInfo.redirectData.comingFromSC = !this.isCalledFromJD;
    extraInfo.redirectData.modal_open_reason = this.type;
    return extraInfo;
  }

  setRangeSliderValues(event: RangeValues) {
    this.rangeSliderLowValue = event.lowValue;
    this.rangeSliderHighValue = event.highValue;
  }

  removeErrorMessages() {
    this.showJobtitleMandatoryErrorMessage = false;
    this.showSkillMandatoryErrorMessage = false;
    this.showLocationMandatoryErrorMessage = false;
    this.showCompanyIndustryMandatoryErrorMessage = false;
    this.showCompanyNameMandatoryErrorMessage = false;
    this.showCompanySizeMandatoryErrorMessage = false;
  }

  selectRegion(region) {
    if (this.showregion === region) 
      return;

    this.showregion = region;
    this.locationExtendedChipList = [];
    this.locationTypeAheads = [];
    this.setSimDataAndFetchRecCount();
  }
  removeTypeahead(type: any){
    const maxLength = 3
    switch (type) {
      case 'jobtitle': {
        if (!(this.jobTitleInput && this.jobTitleInput.value && this.jobTitleInput.value.length >= maxLength)) {
          this.jobTitleTypeAheads = []
        }
        break;
      }
      case 'skills': {
        if (!(this.skillInput && this.skillInput.value && this.skillInput.value.length >= maxLength)) {
          this.skillTypeAheads = []
        }
        break;
      }
      case 'companyindustry': {
        if (!(this.companyIndustryInput && this.companyIndustryInput.value && this.companyIndustryInput.value.length >= maxLength)) {
          this.companyIndustryTypeAheads = []
        }
        break;
      }
      case 'fieldofstudy': {
        if (!(this.fieldOfStudyInput && this.fieldOfStudyInput.value && this.fieldOfStudyInput.value.length >= maxLength)) {
          this.fieldOfStudyTypeAheads = []
        }
        break;
      }
      case 'school': {
        if (!(this.schoolInput && this.schoolInput.value && this.schoolInput.value.length >= maxLength)) {
          this.schoolTypeAheads = []
        }
        break;
      }
      case 'location': {
        if (!(this.locationInput && this.locationInput.value && this.locationInput.value.length >= maxLength)) {
          this.locationTypeAheads = []
        }
        break;
      }
      case 'companyname': {
        if (!(this.companyNameInput && this.companyNameInput.value && this.companyNameInput.value.length >= maxLength)) {
          this.companyNameTypeAheads = []
        }
        break;
      }
      case 'location': {
        if (!(this.locationInput && this.locationInput.value && this.locationInput.value.length >= maxLength)) {
          this.locationTypeAheads = []
        }
        break;
      }
      case 'degreeinput': {
        if (!(this.degreeInput && this.degreeInput.value && this.degreeInput.value.length >= maxLength)) {
          this.degreeTypeAheads = []
        }
        break;
      }
    }
  }
}
